import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import grid from '../assets/graphic.png'

export class BottomPart extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  
  render() {
    return (
      <Row className='info-row'>
        <Col sm={12} lg={6} className='grid-col'>
          <h2 className='info-title'>
            Where do we get the data?
          </h2>
          <p className='info-text mobile-margin'>
            Glimpse analyzes hundreds of millions of consumer behavior signals from across the web to surface topics with rapidly growing or declining popularity.
          </p>
          <img src={grid} alt="" className='grid' />
        </Col>
        <Col sm={12} lg={6} className='text-col'>
          <h2 className='info-title'>
            Why is This Useful?
          </h2>
          <p className='info-text'>
            In addition to its grave effect on the healthcare system, the cascading effects of Coronavirus are massively impacting the economy.
          </p>
          <p className='info-text'>
            The pandemic is reshaping everything from how we work and shop to how we exercise and socialize.
          </p>
          <p className='info-text'>
            We’re hopeful that by shedding light on products with excess demand and often insufficient supply, businesses can more easily focus on the things that matter most and be better stewards to the world in this time of crisis.
          </p>
        </Col>
      </Row>
    )
  }
}
